module.exports = __webpack_public_path__ + "static/img/icon_standard_medical.44a8626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GlobalRescue/icon_standard_medical.png
// module id = APqz
// module chunks = 1